import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const PaymentMethodIcon: FunctionComponent<{ source: string; height: number; mx: string }> = observer(
  ({ source, height, mx }) => (
    <div className={mx}>
      <img src={source} alt="" height={height} />
    </div>
  )
);

export default PaymentMethodIcon;
